<template>
  <modal :modal-key="'resume_game'" :class-style="'modal modal--resume_game'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_resume_game_welcome_back }} {{ userDetails.username }}!</h1>
      <h2>{{ getTranslations.home_modals_resume_game_msg_to_continue_the_game }}</h2>
      <div class="avatars">
        <div class="avatar avatar--player1">
          <img :src="playersDetails.homePlayerAvatar" alt="">
          <span>{{ playersDetails.homePlayerUsername }}</span>
        </div>
        <div class="avatar  versus">
          <img src="static/images/versus_icon.svg" alt="">
        </div>
        <div class="avatar avatar--player2">
          <img :src="playersDetails.awayPlayerAvatar" alt="">
          <span>{{ playersDetails.awayPlayerUsername }}</span>
        </div>
      </div>
    </template>
    <template slot="body">
      <a @click.prevent="resumeGame" style="cursor:pointer" class="btn2 btn2--std btn2--medium">{{
        getTranslations.home_modals_resume_game_resume_game }}</a>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'resume-game',
  components: {
    Modal,
  },
  beforeDestroy() {
    // eslint-disable-next-line
    console.log('in ResumeGame beforeDestroy hook');
    this.storeModalForHomePage(null);
    this.storeModalForChallenge(null);
  },
  methods: {
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForChallenge',
    ]),
    ...mapMutations('game', [
      'setGameResuming',
      'setTransitionOnlyForSearchingToOpponent',
    ]),
    resumeGame() {
      this.setGameResuming(true);
      this.storeModalForHomePage(null);
      this.storeModalForChallenge(null);
      if (this.transitionOnlyForSearchingToOpponent) {
        this.setTransitionOnlyForSearchingToOpponent(false);
      }
      this.checkIfGameToResumeExists().then(() => {
        if (this.gameInProgress) {
          this.$router.replace('/resumingGame');
        } else {
          this.getUserLoginDetails().then(() => {
            this.storeModalForHomePage(null);
          });
        }
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'gameInProgress',
      'transitionOnlyForSearchingToOpponent',
      'playersDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ResumeGame.vue